import React, { FC } from 'react'

import SvgAngleRight from '@Assets/SVG/AngleRight'
import Arrow from '@Components/Product/Slider/Components/Arrow'

interface Props {
  className?: string
  onClick?: (event) => void
}

const RightArrow: FC<Props> = ({ className, onClick }) => (
  <Arrow
    className={className}
    onClick={onClick}
    svg={<SvgAngleRight />}
  />
)

export default RightArrow
